var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.magicData.magicArr),function(item,index){return [_c(item.name,{key:index,tag:"component",attrs:{"id":_vm.id,"content":item.content},on:{"image-click":_vm.goPage}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }